// Generated from ContestStageScore's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestStageScoreCollectionFilterGroups
  = | {
    readonly participant: Iri
  }
  | {
    readonly participantCategory: Iri | Iri[]
    readonly stage: Iri
  }

export const contestStageScoreCollectionFilterMapping: FilterDefinitionMapping<ContestStageScoreCollectionFilterGroups> = {
  participant: 'participant',
  participantCategory: 'participant.category',
  stage: 'stage',
}

export type ContestStageScoreCollectionSort = never
